import { useRouteError, isRouteErrorResponse } from "react-router-dom";
import ErrorPage from "./ErrorPage";

const RouterErrorPage = () => {
  const error = useRouteError();

  // Check if it's a known route error (404, etc.)
  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return (
        <ErrorPage title="404 Page Not Found">
          <p>
            The page you're looking for doesn't exist. Let's get you back on
            track.
          </p>
        </ErrorPage>
      );
    }

    return (
      <ErrorPage title="Something went wrong" showRefreshButton>
        <p>{error.statusText || "An unexpected error occurred."}</p>
      </ErrorPage>
    );
  }

  // For other errors (runtime errors, etc.)
  const errorMessage =
    error instanceof Error ? error.message : "An unexpected error occurred";

  // Check for common error types and provide helpful messages
  const isStorageError =
    errorMessage.toLowerCase().includes("insecure") ||
    errorMessage.toLowerCase().includes("storage") ||
    errorMessage.toLowerCase().includes("quota");

  return (
    <ErrorPage title="Something went wrong" showRefreshButton>
      <p>
        {isStorageError
          ? "This may be caused by private browsing mode or browser security settings. Try disabling private browsing or adjusting your browser's cookie settings."
          : "We encountered an unexpected error. Please try refreshing the page."}
      </p>
      <p className="mt-4 text-sm text-gray-400">
        If this problem persists, please contact support.
      </p>
    </ErrorPage>
  );
};

export default RouterErrorPage;
